// Keep the web and mobile request-location rules in sync.
export function getRequestLocations(stores = [], memberships = []) {
  return stores.filter((store) =>
    store.status !== "closed" && memberships.some((member) =>
      String(member.store) === String(store.id) &&
      !member.is_archived && member.status !== "archived" &&
      member.permission_type !== "company_timeclock"
    )
  );
}

export function requestPayload(data, currentStoreId) {
  return { ...data, store_id: data.store_id ?? currentStoreId };
}

export function requestDestinationMessage(data, currentStoreId, stores = []) {
  const id = data.store_id ?? currentStoreId;
  const name = stores.find((store) => String(store.id) === String(id))?.store_name;
  return name ? `Request submitted to ${name}.` : "Request submitted.";
}
